<template>
    <div class="leasingVehicleCard">
        <a
            :href="url"
            class="leasingVehicleCard__image"
        >
            <img
                v-if="image"
                :src="image"
                :alt="`${title}`"
                :title="`${title}`"
                width="232"
                height="176"
            />

            <img src="/sites/petervardy/images/noImage320x240.jpg" :alt="`${title} - No Image`" v-else>

            <div class="leasingVehicleCard__chips" v-if="chips.length > 0">
                <div class="leasingVehicleCard__chip" v-for="(chip, index) in chips" :key="`chip-${index}`">
                    {{ chip }}
                </div>
            </div>
        </a>

        <div class="leasingVehicleCard__body">
            <a :href="url">
                <h2 class="leasingVehicleCard__title" v-if="title">
                    {{ title }}
                </h2>

                <h3 class="leasingVehicleCard__subtitle" v-if="derivative">{{ derivative }}</h3>
            </a>

            <div
                v-if="cheapestFinance && cheapestFinance.monthly_rental > 0"
                class="leasingVehicleCard__price"
            >
                <div class="leasingVehicleCard__price__label">
                    Monthly rental
                    <span class="leasingVehicleCard__price__vat">(inc VAT)</span>
                </div>

                <div class="leasingVehicleCard__price__value">
                    {{ cheapestFinance.monthly_rental|formatCurrency }}
                </div>
            </div>

            <ul class="leasingVehicleCard__contractList">
                <li class="leasingVehicleCard__contractList__item">Personal Contract Hire</li>
                <li class="leasingVehicleCard__contractList__item" v-if="cheapestFinance && cheapestFinance.initial_payment">Initial Rental: {{ cheapestFinance.initial_payment|formatCurrency }}</li>
                <li class="leasingVehicleCard__contractList__item" v-if="cheapestFinance && cheapestFinance.term">{{ cheapestFinance.term }} Month Contract</li>
                <li class="leasingVehicleCard__contractList__item" v-if="cheapestFinance && cheapestFinance.mileage">{{ cheapestFinance.mileage|formatNumber }} Miles pa</li>
            </ul>

            <div class="leasingVehicleCard__buttonGroup">
                <a :href="url" class="redesignButton redesignButton--green redesignButton--full">View Deal</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: Number
        },
        url: {
            type: String
        },
        title: {
            type: String
        },
        derivative: {
            type: String
        },
        price: {
            type: [Number, String]
        },
        image: {
            type: String
        },
        vehicleType: {
            type: String
        },
        highlightText: {
            type: String
        },
        cheapestFinance: {
          type: Object
        },
        result: {
          type: Object
        },
    },
    computed: {
        chips() {
            let chips = []

            if (this.highlightText) {
                chips.push(this.$options.filters.truncate(this.highlightText))
            }

            return chips
        }
    },
    filters: {
        formatCurrency(value) {
            return new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
            }).format(value);
        },
        formatNumber(value) {
            return new Intl.NumberFormat().format(value);
        },
        truncate(value, length = 32, append = '...') {
            if (value && value.length > length) {
                value = value.substring(0, length) + append
            }

            return value
        }
    }
}
</script>
